import { putSubmissionTaskStatus } from '@common/services/submissionTaskService';
import { selectUserId } from '@common/features/user/selectors';
import { SubmissionTaskStatuses } from '@common/services/types';
import useWaitingMutation from '@common/hooks/useWaitingMutation';
import { useAppSelector } from './redux';

interface ITaskStatusChange {
  taskId: string;
  status: SubmissionTaskStatuses;
  additionalInformation?: string;
}

export const useTaskStatusChange = () => {
  const userId = useAppSelector(selectUserId);

  const { mutate, isLoading } = useWaitingMutation(({ taskId, status, additionalInformation = '' }: ITaskStatusChange) =>
    putSubmissionTaskStatus(taskId, { userId, additionalInformation, status }),
  );

  return { changeTaskStatus: mutate, isChangingTaskStatus: isLoading };
};
